// extracted by mini-css-extract-plugin
export default {"root":"InlineArtist_root__2R2TN"};